import {Endpoint} from '@eryxcoop/appyx-comm';

export default class GetOrderOptionsEndpoint extends Endpoint {

  adaptValues(partialOrder) {
    return {
      "customer": {
        "business_name": partialOrder.businessName,
        "fantasy_name": partialOrder.fantasyName,
        "code": partialOrder.customerCode,
      },
      "delivery_site": {
        "name": partialOrder.deliverySiteName,
        "address": partialOrder.deliverySiteAddress,
        "city": partialOrder.deliverySiteCity,
      },
    }
  }
}